module.exports = __webpack_public_path__ + "static/UNITY-TOWER-1st-floor-traditional_v2-e9fdd50dbed87b93324cf1fb0fd03cf0.pdf";